const miscFormat = {
	userIcon: {
		width: '40px',
		minWidth: '40px',
		borderRadius: '50%',
	},

	productPaperPadding: {
		padding: '6px 12px',
	},

	setHeight100: {
		// this is needed to pass the height through the material UI cards
		// without it, the cards are not uniform in size.
		height: '100%',
	},

	cardTitlePadding: {
		padding: '0.1em 0.3em 0.2em 0.3em',
	},

	cardSubtitleStyle: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: '0.667em', // subtitle font size is 2/3 title font size
		lineHeight: '1.5em',
	},

	cardSubtitleFlex: {
		display: 'flex',
	},

	cardSubtitleMsrp: {
		textDecoration: 'line-through',
		paddingLeft: '0.5em',
	},

	cardSubtitleSku: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		marginLeft: 'auto',
	},

	cardTitleStyle: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: '1em',
		lineHeight: '1.5em', // Otherwise some letters (g,p,q,j,y) are cut off
	},

	// Styling for the parent category bar text
	parentCatTextStyle: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		maxWidth: 'calc(100% - 16px)',
		display: 'inline-block',
		padding: '0px 8px',
	},
};

export default miscFormat;
